import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { CartDrawer } from "@/components/CartDrawer";
import { ReservationModal } from "@/components/ReservationModal";
import { ScrollToTop } from "@/components/ScrollToTop";
import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import AppPage from "@/pages/AppPage";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Reviews from "@/pages/Reviews";
import Careers from "@/pages/Careers";
import Policy from "@/pages/Policy";
import Auth from "@/pages/Auth";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <CartProvider>
            <ScrollToTop />
            <Header />
            <CartDrawer />
            <ReservationModal />
            <main>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/shop" element={<Shop />} />
                <Route path="/app" element={<AppPage />} />
                <Route path="/about" element={<About />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/reviews" element={<Reviews />} />
                <Route path="/careers" element={<Careers />} />
                <Route path="/warranty" element={<Policy slug="warranty" />} />
                <Route path="/shipping" element={<Policy slug="shipping" />} />
                <Route path="/returns" element={<Policy slug="returns" />} />
                <Route path="/privacy" element={<Policy slug="privacy" />} />
                <Route path="/terms" element={<Policy slug="terms" />} />
                <Route path="/cookies" element={<Policy slug="cookies" />} />
                <Route path="/licenses" element={<Policy slug="licenses" />} />
                <Route path="/auth" element={<Auth />} />
              </Routes>
            </main>
            <Footer />
            <Toaster position="top-center" richColors />
          </CartProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
